import { IUserRole } from 'app/services/user';
import { getUserRole, useAuth } from 'utils/AuthProvider';

export interface IUserRoleProps {
  roles: IUserRole[] | undefined;
}

export default function UserRole({ roles }: IUserRoleProps) {
  return (
    <div className="py-1 px-1.5 rounded-xl bg-gray-400 text-gray-700 capitalize text-xs my-1 w-min">
      {getUserRole(roles).roleName}
    </div>
  );
}
